import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.rentalStores.replace(appPath.rental, ''),
	components: () => [],
	render: (_, children) => children,
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'rentalStores' */ './RentalStoreMap')],
			render: ([RentalStoreMap]) => <RentalStoreMap />,
		},
		{
			path: '/:id',
			components: () => [import(/* webpackChunkName: 'rentalStores' */ './RentalStores')],
			render: ([RentalStores]) => <RentalStores />,
		},
	],
};

export default routes;
